"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var myokay_map3_1 = require("@okay/myokay-map3");
var PinRenderer_1 = require("@/pages/search/components/PinRenderer");
var mapDispatchToProps = function (dispatch) { return ({
    onMapReady: function () { return dispatch(SearchMapAction_1.default.onMapReady()); },
    addCacheData: function (cacheData) { return dispatch(SearchMapAction_1.default.addCacheData(cacheData)); },
    onViewportChanged: function (viewport) { return dispatch(SearchMapAction_1.default.onViewportChanged(viewport)); },
    onCancel: function () { return dispatch(SearchMapAction_1.default.onCancel()); },
    setPinActive: function (pin) { return dispatch(SearchMapAction_1.default.setPinActive(pin)); },
    zoomInPin: function (pin) { return dispatch(SearchMapAction_1.default.zoomInPin(pin)); },
    setPinInactive: function (pin) { return dispatch(SearchMapAction_1.default.setPinInactive(pin)); },
    toggleFav: function (id) { return dispatch(SearchMapAction_1.default.toggleFav(id)); },
}); };
var mapStateToProps = function (state) { return (__assign(__assign({}, state.mapsearch), { results: state.results, imgDomain: state.layout.imgDomain, lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, symbol: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol })); };
var searchMap = function (props) {
    if (!props.camera && !props.minZoom)
        return React.createElement(React.Fragment, null);
    var cacheConfig = myokay_map3_1.getDefaultCacheConfig(myokay_map3_1.layerDefinitionDefault);
    return (React.createElement(myokay_map3_1.CacheCluster, { cacheData: props.cacheData, clusterConfig: props.clusterConfig, clusterer: myokay_map3_1.defaultClusterer, cacheConfig: cacheConfig, onMapReady: props.onMapReady, onViewportChanged: props.onViewportChanged, onCancel: props.onCancel, pinRenderer: PinRenderer_1.pinRenderer(props), camera: props.camera, extraPins: props.extraPins, minZoom: props.minZoom, zoomControl: true }));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(searchMap);
